import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, {useEffect} from 'react'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'
import {useHistory, useLocation} from 'react-router-dom'

import * as cross from '../store/cross'
import * as dashboardActions from '../actions/dashboard'
import * as dashboard from '../store/dashboard'
import * as site from '../store/site'

import asyncComponent from '../components/HOC/asyncComponent'
import Curtain from '../components/Dashboard/Curtain'
import Throbber from '../components/Throbber'
import * as user from '../store/user'

import '../../scss/components/dashboard/_dashboard-container.scss'

const DashboardAsync = asyncComponent(
  () => import('../components/Dashboard/Dashboard' /* webpackChunkName: "dashboard" */),
  {loading: () => <Throbber />},
)

const checkPreload = (isAuthenticated, windowOnloadFired) => {
  // Preload should happen as early as possible, to minimize the chance of a delay when the user
  // opens the dashboard. But it shouldn't happen before the window onload event has fired, because
  // that would delay onload until after the preload has finished.
  if (windowOnloadFired && isAuthenticated) {
    DashboardAsync.preload()
  }
}

const DashboardContainer = ({
  isAuthenticated,
  isOpen,
  openDashboard,
  toggle,
  userIsOwner,
  windowOnloadFired,
}) => {
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    checkPreload(isAuthenticated, windowOnloadFired)
  }, [isAuthenticated, windowOnloadFired])

  const dashboardClasses = classNames('dashboard', {
    'is--open': isOpen,
  })

  // Temporary solution to trigger the dashboard when customers click to view
  // their HTO look from the fe-core dashboard instance
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const queryKey = 'openDashboard'

    if (queryParams.has(queryKey)) {
      queryParams.delete(queryKey)
      history.replace({
        search: queryParams.toString(),
      })
      openDashboard()
    }
  }, [location])

  return (
    userIsOwner && (
      <div className={dashboardClasses}>
        <div className="dashboard-itself">{isOpen && <DashboardAsync />}</div>
        <Curtain toggleDashboard={toggle} />
      </div>
    )
  )
}

DashboardContainer.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  openDashboard: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  userIsOwner: PropTypes.bool.isRequired,
  windowOnloadFired: PropTypes.bool.isRequired,
}

const mapStateToProps = createStructuredSelector({
  isAuthenticated: user.isAuthenticated,
  isOpen: dashboard.isOpen,
  userIsOwner: cross.userIsOwner,
  windowOnloadFired: site.windowOnloadFired,
})

export default connect(mapStateToProps, {
  toggle: dashboardActions.toggleDashboard,
  openDashboard: dashboardActions.openDashboard,
})(DashboardContainer)
